import React from 'react'
import axios from 'axios'

export async function SignIn(email, password) {
  const countryCode = localStorage.getItem('countryCode')
  const languageCode = sessionStorage.getItem('languageCode')
  try {
    const res = await axios.get(
      `https://live.aumhum.xyz/api/secure/user/login?languageCode=${languageCode}&countryCode=${countryCode}`,
      {
        auth: {
          username: email,
          password: password,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
